export default __webpack_public_path__ + "static/media/google_g.cadee8cd.png";